export default __webpack_public_path__ + "static/media/dhrumil.176b857a.png";